import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { msg } from 'api';

const getBannersByCategory = (categoryId, brandBanners) =>
  brandBanners.filter(banner => (
    (categoryId === 'highlighted' && banner.displayedInPromotionsSection)
    || (banner.tagIds && banner.tagIds.includes(parseInt(categoryId, 10))
    )
  ));

export default class NavigationBanners extends PureComponent {
  static propTypes = {
    brandBanners: PropTypes.array.isRequired,
    brandBannersWideThreshold: PropTypes.number,
    levelIds: PropTypes.array.isRequired,
    defaultBrandBannersActive: PropTypes.bool,
    pageParameters: PropTypes.object,
  };

  static defaultProps = {
    pageParameters: {},
  };

  get selectedCatId() {
    const { levelIds } = this.props;

    if (!levelIds || !levelIds.length) {
      return null;
    }

    return levelIds[levelIds.length - 1];
  }

  getBannersForPromoSection() {
    const { brandBanners } = this.props;

    return brandBanners.filter((banner) =>
      (banner.displayedInPromotionsSection === true)
    );
  }

  getBanners() {
    const { brandBanners, levelIds, pageParameters, defaultBrandBannersActive: defaultActive } = this.props;

    if (!levelIds.length && defaultActive) {
      return this.getBannersForPromoSection();
    }

    const { selectedCatId } = this;

    let categoryBanners = [];
    if (levelIds.length || selectedCatId) {
      const parentLevelsIds = pageParameters.category ? pageParameters.category.map(cat => parseInt(cat.id, 10)) : [];

      levelIds
        .concat(parentLevelsIds, [selectedCatId])
        .reduce((x, y) => { // remove duplicates
          let id = y;
          if (y !== 'highlighted') id = parseInt(y, 10);
          if (x.includes(id)) {
            return x;
          } else {
            return [...x, id];
          }
        }, [])
        .forEach(categoryId => {
          categoryBanners = categoryBanners.concat(
            getBannersByCategory(categoryId, brandBanners)
          );
        });
    }

    return categoryBanners;
  }

  render() {
    const { brandBannersWideThreshold } = this.props;
    const isBrandBannersWideThresholdSet = brandBannersWideThreshold && brandBannersWideThreshold > 0;
    const categoryBanners = this.getBanners();

    if (!categoryBanners.length) {
      return null;
    }

    const shouldAddWideClass = isBrandBannersWideThresholdSet && categoryBanners.length > brandBannersWideThreshold;

    return (
      <div className={classNames('navigationBanners', { 'navigationBanners--wide': shouldAddWideClass })}>
        <h3 className="navBanners__heading">{msg.nav.labels.bannersTitle}</h3>
        <ul className="navBanners__list">
          {categoryBanners.map((banner, idx) => {
            const key = `${banner.shopId}${idx}`;
            return (
              <li className="navBanners__item" key={key}>
                <a className="navBanners__link" href={`/webshop/getBrandShop.go?shopId=${banner.shopId}`}>
                  <img
                    src={banner.imageSrc}
                    alt={banner.title}
                    title={banner.title}
                    className="navBanners__img"
                  />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
